import { Container } from 'react-bootstrap';
import './Header.css';

const Header = () => {
  return (
    <div className="PrimaryNav-wrapper">
      <Container fluid className="PrimaryNav">
        <a href="https://www.mathematica.org">
          <img src="./images/logo-tagline@2x.png" alt="MPR-logo-tagline" />
        </a>
      </Container>
    </div>
  )
}

export default Header;
